var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9",
    "data-name": "Group 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.613,
    height: 30.612,
    viewBox: "0 0 30.613 30.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M800.126,395.424a15.306,15.306,0,1,1,15.283,15.319A15.256,15.256,0,0,1,800.126,395.424Zm13.782-2.817h0q0,2.349,0,4.7a2,2,0,0,0,.056.6A1.573,1.573,0,0,0,815.617,399a1.524,1.524,0,0,0,1.334-1.493c.015-1.159.006-2.319.006-3.478q0-3.084,0-6.168a1.544,1.544,0,0,0-1.052-1.54,1.524,1.524,0,0,0-1.991,1.444C813.9,389.38,813.908,390.994,813.908,392.608Zm-.513,9.973a2.02,2.02,0,0,0,2.043,2.044,2.048,2.048,0,0,0,2.03-2.031,2.081,2.081,0,0,0-2.052-2.055A2.059,2.059,0,0,0,813.4,402.581Z",
    transform: "translate(-800.126 -380.132)",
    fill: "#ec2128"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M944.044,450.386c0-1.614-.012-3.228,0-4.841a1.524,1.524,0,0,1,1.991-1.444,1.544,1.544,0,0,1,1.052,1.54q.006,3.084,0,6.168c0,1.16.009,2.319-.006,3.478a1.524,1.524,0,0,1-1.334,1.493,1.573,1.573,0,0,1-1.654-1.093,2,2,0,0,1-.056-.6q0-2.349,0-4.7Z",
    transform: "translate(-930.261 -437.91)",
    fill: "#fdfdfd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M938.723,595.326a2.058,2.058,0,0,1,2.021-2.042,2.081,2.081,0,0,1,2.052,2.055,2.048,2.048,0,0,1-2.03,2.031A2.02,2.02,0,0,1,938.723,595.326Z",
    transform: "translate(-925.454 -572.877)",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.160d8e7f3584aaa592b1639a1538daca.svg";
export { ForwardRef as ReactComponent };